import { ReactElement, useCallback } from 'react';

import { Dropdown, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys, visitTranslationKeys } from '../../../../translations';

type PatientHistoryDropdownItemProps = {
   readonly patientId: number;
};
export const PatientHistoryDropdownItem = (props: PatientHistoryDropdownItemProps): ReactElement => {
   const push = useHistoryPushWithBackAction(true);

   const handleClick = useCallback(
      (hide) => {
         push(
            visitPaths.getVisitHistoryPath({
               params: {
                  patientId: props.patientId,
               },
               searchParams: {},
            }),
            {
               label: visitTranslationKeys.goBackToAppointmentsList,
            }
         );
         hide();
      },
      [props.patientId, push]
   );

   return (
      <Dropdown.Item testId={'patientHistory'} onClick={handleClick}>
         {appointmentsTranslationKeys.patientHistory}
      </Dropdown.Item>
   );
};
